<template>
  <div
    v-if="visible"
    class="fixed inset-0 z-50 flex items-end sm:items-center justify-center px-4 pb-6 sm:pb-0"
    role="dialog"
    aria-modal="true"
    aria-labelledby="pwa-install-help-title"
  >
    <div class="absolute inset-0 bg-black bg-opacity-60" @click="close" />
    <div class="relative w-full max-w-sm bg-white rounded-lg shadow-xl p-5">
      <h3 id="pwa-install-help-title" class="text-lg font-semibold text-gray-900">
        Install the EBM app
      </h3>

      <ol v-if="isIos" class="mt-4 space-y-3 text-sm text-gray-700">
        <li class="flex items-start">
          <span class="mr-2 font-semibold text-red-700">1.</span>
          <span>
            Tap the
            <span class="inline-flex align-middle mx-1 text-blue-600" aria-hidden="true">
              <svg class="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 3a1 1 0 01.7.3l4 4a1 1 0 11-1.4 1.4L13 6.42V16a1 1 0 11-2 0V6.41L8.7 8.7a1 1 0 11-1.4-1.42l4-4A1 1 0 0112 3z" />
                <path d="M5 12a1 1 0 011 1v5h12v-5a1 1 0 112 0v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6a1 1 0 011-1z" />
              </svg>
            </span>
            Share button in Safari.
          </span>
        </li>
        <li class="flex items-start">
          <span class="mr-2 font-semibold text-red-700">2.</span>
          <span>Scroll and tap <strong>Add to Home Screen</strong>.</span>
        </li>
        <li class="flex items-start">
          <span class="mr-2 font-semibold text-red-700">3.</span>
          <span>Tap <strong>Add</strong>. The EBM icon will appear on your home screen.</span>
        </li>
      </ol>

      <ol v-else class="mt-4 space-y-3 text-sm text-gray-700">
        <li class="flex items-start">
          <span class="mr-2 font-semibold text-red-700">1.</span>
          <span>Open the browser menu (the three dots).</span>
        </li>
        <li class="flex items-start">
          <span class="mr-2 font-semibold text-red-700">2.</span>
          <span>Tap <strong>Install app</strong> or <strong>Add to Home screen</strong>.</span>
        </li>
        <li class="flex items-start">
          <span class="mr-2 font-semibold text-red-700">3.</span>
          <span>Confirm. The EBM icon will appear on your home screen.</span>
        </li>
      </ol>

      <button
        type="button"
        class="mt-5 w-full rounded-md bg-red-700 text-white text-sm font-semibold py-2 px-3 hover:bg-red-600 focus:outline-none"
        @click="close"
      >
        Got it
      </button>
    </div>
  </div>
</template>

<script>
import eventBus from "../utils/eventBus";
import { isIosDevice } from "../utils/pwaInstall";

export default {
  name: "PwaInstallHelpModal",
  data() {
    return {
      visible: false,
      isIos: isIosDevice(),
    };
  },
  created() {
    eventBus.$on("pwa-show-ios-help", this.openIos);
    eventBus.$on("pwa-show-browser-help", this.openBrowser);
  },
  beforeDestroy() {
    eventBus.$off("pwa-show-ios-help", this.openIos);
    eventBus.$off("pwa-show-browser-help", this.openBrowser);
  },
  methods: {
    openIos() {
      this.isIos = true;
      this.visible = true;
    },
    openBrowser() {
      this.isIos = false;
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
  },
};
</script>
